function initProductGalleries(root=document){
  root.querySelectorAll('[data-product-gallery]').forEach(gallery=>{
    if(gallery.dataset.ready)return;
    gallery.dataset.ready='true';
    const slides=Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    if(!slides.length)return;
    const track=gallery.querySelector('[data-gallery-track]');
    const viewport=gallery.querySelector('[data-gallery-viewport]');
    const dots=Array.from(gallery.querySelectorAll('[data-gallery-dot]'));
    const status=gallery.querySelector('[data-gallery-status]');
    const controls=gallery.querySelector('[data-gallery-controls]');
    const controller=new AbortController();
    const options={signal:controller.signal};
    const reduced=matchMedia('(prefers-reduced-motion: reduce)');
    let index=Math.max(0,slides.findIndex(slide=>slide.dataset.mediaId===gallery.dataset.initialMedia));
    let timer=null,hover=false,focused=false,start=null,dragged=false,inView=true;
    gallery.classList.add('gallery-enhanced');
    viewport.scrollLeft=0;
    if(controls)controls.hidden=false;
    function schedule(){
      clearInterval(timer);timer=null;
      if(slides.length>1&&!reduced.matches&&!document.hidden&&!hover&&!focused&&!start&&inView&&slides[index].dataset.mediaType==='image'){
        timer=setInterval(()=>show(index+1,false),3000);
      }
    }
    function show(next,manual=true){
      index=(next+slides.length)%slides.length;
      track.style.transform='translateX(-'+index*100+'%)';
      slides.forEach((slide,i)=>{
        const active=i===index;slide.inert=!active;slide.setAttribute('aria-hidden',String(!active));
        if(!active)slide.querySelectorAll('video').forEach(video=>video.pause());
      });
      dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));
      if(manual)status.textContent=slides[index].getAttribute('aria-label');
      schedule();
    }
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>show(index-1),options);
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click',()=>show(index+1),options);
    dots.forEach(dot=>dot.addEventListener('click',()=>show(Number(dot.dataset.galleryDot)),options));
    gallery.addEventListener('gallery:select',event=>{const next=slides.findIndex(slide=>slide.dataset.mediaId===String(event.detail.mediaId));if(next>=0)show(next);},options);
    gallery.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){hover=true;schedule();}},options);
    gallery.addEventListener('pointerleave',()=>{hover=false;schedule();},options);
    gallery.addEventListener('focusin',()=>{focused=true;schedule();},options);
    gallery.addEventListener('focusout',event=>{if(!gallery.contains(event.relatedTarget)){focused=false;schedule();}},options);
    gallery.addEventListener('keydown',event=>{if(event.target.closest('video,iframe,model-viewer'))return;if(event.key==='ArrowRight'){event.preventDefault();show(index+1);}if(event.key==='ArrowLeft'){event.preventDefault();show(index-1);}},options);
    viewport.addEventListener('pointerdown',event=>{if(slides[index].dataset.mediaType!=='image'||event.button>0)return;start={x:event.clientX,y:event.clientY,id:event.pointerId};dragged=false;clearInterval(timer);},options);
    viewport.addEventListener('pointermove',event=>{if(!start)return;if(Math.abs(event.clientX-start.x)>10){dragged=true;viewport.setPointerCapture(event.pointerId);}},options);
    viewport.addEventListener('pointerup',event=>{if(!start)return;const dx=event.clientX-start.x,dy=event.clientY-start.y;start=null;if(Math.abs(dx)>35&&Math.abs(dx)>Math.abs(dy))show(index+(dx<0?1:-1));schedule();},options);
    viewport.addEventListener('pointercancel',()=>{start=null;schedule();},options);
    viewport.addEventListener('click',event=>{if(dragged){event.preventDefault();dragged=false;}},options);
    viewport.addEventListener('dragstart',event=>event.preventDefault(),options);
    document.addEventListener('visibilitychange',schedule,options);
    reduced.addEventListener('change',schedule,options);
    const observer=typeof IntersectionObserver==='function'?new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;schedule();}):null;
    observer?.observe(gallery);
    gallery.addEventListener('gallery:destroy',()=>{clearInterval(timer);observer?.disconnect();controller.abort();},{once:true});
    show(index,false);
  });
}
initProductGalleries();
document.addEventListener('shopify:section:load',event=>initProductGalleries(event.target));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-product-gallery]').forEach(gallery=>gallery.dispatchEvent(new Event('gallery:destroy'))));
